<template>
  <div class="partner-wrap">
    <div class="partner-title-box">
      <h2 class="partner-title">合作伙伴</h2>
      <p class="partner-sub">CORE ADVANTAGES</p>
    </div>

    <div class="partner-card-list">
      <div class="partner-card">
        <div class="card-bg">
          <div class="card-text">
            <h3>高校院所</h3>
            <p>COLLEGES AND UNIVERSITIES</p>
          </div>
        </div>
      </div>

      <div class="partner-card">
        <div class="card-bg-two">
          <div class="card-text">
            <h3>企业</h3>
            <p>ENTERPRISES</p>
          </div>
        </div>
      </div>

      <div class="partner-card">
        <div class="partner-card">
          <div class="card-bg-three">
            <div class="card-text">
              <h3>政府</h3>
              <p>GOVERNMENT AGENCIES</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerThreeBox"
};
</script>

<style scoped>
.partner-wrap {
  background-color: #f0f7ff;
  padding: 70px 20px;
  margin: 0 auto;
  margin-top: 20px;
  box-sizing: border-box;
  max-width: 1600px;
  
}

.partner-title-box {
  margin: 0 auto 50px;
  text-align: center;
}

.partner-title {
  font-size: 3rem;
  font-weight: bold;
  color: #003388;
  margin: 0 0 8px 0;
}
.partner-sub {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.partner-card-list {
  margin: 0 auto;
  display: flex;
  gap: 30px;
}

.partner-card {
  flex: 1;
}

.card-bg {
  width: 100%;
  aspect-ratio: 5 / 7;
  background: url("~@/assets/images/yx.png") no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  position: relative;
}
.card-bg-two{
   width: 100%;
  aspect-ratio: 5 / 7;
  background: url("~@/assets/images/qy.png") no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  position: relative;
}
.card-bg-three{
   width: 100%;
  aspect-ratio: 5 / 7;
  background: url("~@/assets/images/zf.png") no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  position: relative;
}

.card-text {
  position: absolute;
  top: 10%;
  left: 10%;
}
.card-text h3 {
  font-size: 33px;
  font-weight: bold;
  color: #0a369d;
  margin: 0 0 6px 0;
}
.card-text p {
  font-size: 18px;
  color: #666;
  margin: 0;
}
@media (max-width: 1400px) and (min-width: 900px) {
  .card-text h3 {
    font-size: 30px;
  }
  .card-text {
    top: 8%;
    left: 8%;
  }
  .card-text p {
    font-size: 14px;
  }
}
@media (max-width: 900px) and (min-width: 768px) {
  .card-text {
    top: 10%;
    left: 8%;
  }
  .card-text h3 {
    font-size: 22px;
  }
  .card-text p {
    font-size: 15px;
  }
}
@media (max-width: 768px) {
  .partner-card-list {
    flex-direction: column;
    gap: 20px;
  }
  .card-text {
    top: 10%;
    left: 8%;
  }
  .card-text h3 {
    font-size: 24px;
  }
  .card-text p {
    font-size: 14px;
  }
}
</style>